import * as React from 'react';
import { Container, Row, Col, Heading } from 'seduo-ui';
import classNames from 'classnames';
import striptags from 'striptags';
const Cover = ({ color, images, leftButton, rightButton, rightButtonDelimiter, title, titleSmall, description, withBackgroundImage, animated, children, className, }) => (<div className={classNames('cover', color ? `bg-${color}` : '', className)}>
        <div className={classNames({
        cover__overlay: !withBackgroundImage,
    })}>
            {!withBackgroundImage && images === null && <div className="cover__gradient"/>}
            {children}
            <div className={classNames({
        'cover__container--with-background-image': withBackgroundImage,
    })}>
                <Container className={classNames('cover__container')}>
                    <Row noGutters className={classNames('cover__container-wrapper')}>
                        <Col sm={12} md={images === null ? 10 : 8} lg={8} className={classNames('cover__text', {
        'cover__text--animated': animated,
    })}>
                            <Row noGutters className="my-auto">
                                <Col sm={12}>
                                    <Heading level={1} className={classNames('hero-text cover__title', {
        'hero-text--small': titleSmall,
    })}>
                                        <div dangerouslySetInnerHTML={{
        __html: title,
    }}/>
                                    </Heading>
                                </Col>
                                {description && (<Col sm={12}>
                                        <p className="cover__description" dangerouslySetInnerHTML={{
            __html: description,
        }}/>
                                    </Col>)}
                                {leftButton && (<React.Fragment>
                                        <Col sm={12} md="auto">
                                            {leftButton}
                                        </Col>
                                        {rightButton && (<Col sm={12} md="auto" className="cover__button-delimiter-wrapper">
                                                <span className="cover__button-delimiter">{rightButtonDelimiter}</span>
                                            </Col>)}
                                    </React.Fragment>)}
                                {rightButton && (<Col sm={12} md="auto" className="cover__button-right-wrapper">
                                        {rightButton}
                                    </Col>)}
                            </Row>
                        </Col>
                        {images && images.length > 0 && (<Col sm={12} md={4} className="cover__image-wrapper">
                                <img src={images[0]} srcSet={images.join(', ')} alt={striptags(title)} className={classNames('cover__image', {
            'cover__image--animated': animated,
        })}/>
                            </Col>)}
                    </Row>
                </Container>
            </div>
        </div>
    </div>);
Cover.defaultProps = {
    color: null,
    images: null,
    description: null,
    leftButton: null,
    rightButton: null,
    children: null,
    className: '',
    titleSmall: false,
    withBackgroundImage: false,
    animated: false,
};
export default Cover;
